import {
  AuthenticationBootstrappedEvent,
  UserLogoutEvent,
  UserLoggedEvent,
  UserAccountEvents,
  UserStatusRequestEvent,
  UserStatusResponseEvent,
} from "../types";

type UserLoggedEventListener = (event: UserLoggedEvent) => void;
type UserLogoutEventListener = (event: UserLogoutEvent) => void;
type AuthenticationBootstrappedEventListener = (
  event: AuthenticationBootstrappedEvent
) => void;
type UserStatusRequestEventListener = (event: UserStatusRequestEvent) => void;
type UserStatusResponseEventListener = (event: UserStatusResponseEvent) => void;

export function addUserLoggedEventListener(callback: UserLoggedEventListener) {
  window.addEventListener(UserAccountEvents.LOGGED, callback as EventListener);
}

export function removeUserLoggedEventListener(
  callback: UserLoggedEventListener
) {
  window.removeEventListener(
    UserAccountEvents.LOGGED,
    callback as EventListener
  );
}

export function addUserLogoutEventListener(callback: UserLogoutEventListener) {
  window.addEventListener(UserAccountEvents.LOGOUT, callback as EventListener);
}

export function removeUserLogoutEventListener(
  callback: UserLogoutEventListener
) {
  window.removeEventListener(
    UserAccountEvents.LOGOUT,
    callback as EventListener
  );
}

export function addAuthenticationBootstrappedEventListener(
  callback: AuthenticationBootstrappedEventListener
) {
  window.addEventListener(
    UserAccountEvents.BOOTSTRAPPED,
    callback as EventListener
  );
}

export function removeAuthenticationBootstrappedEventListener(
  callback: AuthenticationBootstrappedEventListener
) {
  window.removeEventListener(
    UserAccountEvents.BOOTSTRAPPED,
    callback as EventListener
  );
}

export function addUserStatusRequestEventListener(
  callback: UserStatusRequestEventListener
) {
  window.addEventListener(
    UserAccountEvents.USER_STATUS_REQUEST,
    callback as EventListener
  );
}

export function removeUserStatusRequestEventListener(
  callback: UserStatusRequestEventListener
) {
  window.removeEventListener(
    UserAccountEvents.USER_STATUS_REQUEST,
    callback as EventListener
  );
}

export function addUserStatusResponseEventListener(
  callback: UserStatusResponseEventListener
) {
  window.addEventListener(
    UserAccountEvents.USER_STATUS_RESPONSE,
    callback as EventListener
  );
}

export function removeUserStatusResponseEventListener(
  callback: UserStatusResponseEventListener
) {
  window.removeEventListener(
    UserAccountEvents.USER_STATUS_RESPONSE,
    callback as EventListener
  );
}
